import React from 'react';
import {
    Page,
    BlockTitle,
    Block,
    Col,
    Row,
    Link,
    Card,
    CardContent,
    Icon,
    Preloader,
    List,
    ListItem
} from 'framework7-react';

import './main.css';

import {API_URL} from '../../../api';

import PageBlock from '../../shared/pageBlock/pageBlock';

export default class extends React.Component {

    state = {
        loading: true,
        error: false,
        contact_person: false,
        org_nr: false
    }

    componentDidMount(){
        this.loadXhr();
        this.loadEventsXhr();
    }

    formateTimestamp(timestamp) {

        const date = new Date(timestamp*1000);
        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = "0" + date.getMinutes();

        const month_arr = ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'];

        return day + '. ' + month_arr[month] + ', kl. ' + hours + ':' + minutes.substr(-2);
    }

    formateTimestampDate(timestamp) {

        const date = new Date(timestamp*1000);
        const day = date.getDate();

        return day;
    }

    loadXhr(){
        const self = this;
        
        const uid = this.props.f7route.params.id;

        this.setState({
            loading:true,
        });

        fetch(API_URL+'/org/get', {
            method: 'POST',
            body: JSON.stringify({
              uid: uid
            })
        })
        .then(response => {
        return response.json()
        })
        .then(data => {
            if(data.err_code === 0){
                this.setState({
                    loading: true,
                    error: false,
                    contact: data.contact,
                    org_display_name: data.org_name
                });
                document.title = `Arrangementer - ${data.org_name}`;
                this.get_data_from_brreg(data.org_nr);
            }else{
                this.setState({
                    loading: false,
                    error: true,
                    error_mgs: data.mgs,
                });
            }
        })
        .catch(err => {
        this.setState({
            loading:true,
            error:true,
            error_mgs: 'En ukjent feil har oppstått, prøv igjen senere.'
        });
        })

    }

    loadEventsXhr(){

        const uid = this.props.f7route.params.id;

        this.setState({
            loading_event:true,
        });

        fetch(API_URL+'/org/events', {
            method: 'POST',
            body: JSON.stringify({
              uid: uid
            })
        })
        .then(response => {
        return response.json()
        })
        .then(data => {
            if(data.err_code === 0){
                this.setState({
                    loading_event: false,
                    error_event: false,
                    events: data.events,
                    activities: data.activities
                });
            }else{
                this.setState({
                    loading_event: false,
                    error_event: true,
                    error_event_mgs: data.mgs,
                });
            }
        })
        .catch(err => {
        this.setState({
            loading_event:true,
            error_event:true,
            error_event_mgs: 'En ukjent feil har oppstått, prøv igjen senere.'
        });
        })

    }

    get_data_from_brreg = (org_nr) => {

        fetch(`https://data.brreg.no/enhetsregisteret/api/enheter/${org_nr}`, {
            method: 'GET',
            headers : new Headers(),
            })
            .then(res => res.json())
            .then(
            (result) => {
                if(result.organisasjonsnummer){


                    this.setState({
                        loading: false,
                        brreg: true,
                        org_nr: result.organisasjonsnummer,
                        org_name: result.navn,
                        org_adr: result.forretningsadresse.adresse.join(', '),
                        org_zip_code: result.forretningsadresse.postnummer,
                        org_zip_city: result.forretningsadresse.poststed,
                        org_type: result.organisasjonsnummer.beskrivelse
                    });
                    if(result.hjemmeside){
                        this.setState({web_page:result.hjemmeside});
                    }
                }else{
                    this.setState({
                        loading: false,
                        brreg: false,
                    }); 
                }

            }).catch(err => {
                this.setState({
                    loading: false,
                    brreg: false,
                });
            })
    }

    addhttp = (s) => {
        var prefix = 'http://';
        if (s.substr(0, prefix.length) !== prefix)
        {
            s = prefix + s;
        }
        return s;
    }

    render_available = (r,m) => {

        let sum = r - m;
        if(sum <= 0){
            return <>0 ledige</>;
        }else{
            return <>{sum} ledige</>;
        }
    }

    render_bottombar = () => {
        return <PageBlock width="700px" color="#dfe4ea">
        <Row noGap>
          <Col width="100" small="40">
              <BlockTitle>Vilkår og personvern</BlockTitle>
              <Block>
                <p style={{marginTop:'-8px'}}>
                <Link external target={'_blank'} href="/cookies">
                Informasjonskapsler (Cookies)
                </Link>
                </p>
                <p style={{marginTop:'-8px'}}>
                <Link external target={'_blank'} href="/vilkar-for-deltakere">
                Vilkår for deltakere
                </Link>
                </p>
                <p style={{marginTop:'-8px'}}>
                <Link external target={'_blank'} href="/personvern">
                Personvernerklæring
                </Link>
                </p>
            </Block>
          </Col>
          <Col width="100" small="60">
            <BlockTitle>Bruk Påmeldinger.no på ditt arrangement!</BlockTitle>
            <Block>
                <p>
                Påmeldinger.no er et påmeldingssystem for konferanser, kurs, konserter og events. Vi håndetere betaling og administrativt arbeid i forbindelse med arrangementer.
                </p>
                <Link external target="_blank" href="/">
                  <b>Les mer om Påmeldinger.no</b>
                </Link>
              </Block> 
            </Col>
          </Row>
          <Block className="text-align-center" style={{width:'100%',marginLeft:'auto',marginRight:'auto'}}>
            <Link external href="https://iwd.no/">INTELLIGENT WEB DESIGN AS | Org.Nr. 821 190 932 MVA | www.iwd.no</Link>
          </Block>
        </PageBlock>;
    }
    render() {
        return <Page>
            {this.state.loading_event ?
                <div className="text-align-center" style={{marginTop:'36px',marginBottom:'654px'}}>
                    <Preloader></Preloader>
                    <p>Vent litt</p>
                </div>
            :
            <>
            {this.state.error
            ? 
            <PageBlock width="520px">
                <Card outline style={{color:'#fff', backgroundColor:'#e74c3c',maxWidth:'440px',marginLeft:'auto',marginRight:'auto',marginTop:'36px',marginBottom:'660px'}}>
                    <CardContent>
                        <Icon material="error" style={{marginRight:'12px',marginTop:'-5px'}}/>
                        <span style={{fontSize:'18px'}}>Denne organisasjonen eksisterer ikke.</span>
                    </CardContent>
                </Card>
            </PageBlock>
            :
            <PageBlock width="880px">
            {this.state.events || this.state.activities ? (
                <>
                {this.state.events &&
                <>
                <BlockTitle medium>Arrangementer</BlockTitle>
                {this.state.events.map((n,i) => (
                <Card className={'event-display'} style={{marginBottom:'12px'}}>
                    <List mediaList>
                        <ListItem
                            link={`/e/${n.url}`}
                            title={n.title}
                            subtitle={<>{n.periode.start&&<>Når: <b>{this.formateTimestamp(n.periode.start)} - {this.formateTimestamp(n.periode.end)}</b></>}{n.adr&&<><br/>Hvor: <b>{n.adr}</b></>}</>}
                            after={n.options.max_participants>0&&this.render_available(n.options.max_participants,n.participants)}
                            text={n.desc.replace(/(<([^>]+)>)/gi, "")}
                        >
                            <Card className={'cal-display'} slot="media">
                                <div className={'cal-top-bar'}></div>
                                <div className={'cal-date'}>{this.formateTimestampDate(n.periode.start)}.</div>
                            </Card>
                        </ListItem>
                    </List>
                </Card>
                ))}
                </>
                }
                {this.state.activities &&
                <>
                <BlockTitle medium>Aktiviteter</BlockTitle>
                {this.state.activities.map((n,i) => (
                <Card className={'event-display'} style={{marginBottom:'12px'}}>
                    <List mediaList>
                        <ListItem
                            link={`/e/${n.url}`}
                            title={n.title}
                            subtitle={<>{n.periode_start>0&&<>Startdato: <b>{this.formateTimestamp(n.periode_start)}</b></>}{n.adr&&<><br/>Hvor: <b>{n.adr}</b></>}</>}
                            after={n.options.max_participants>0&&this.render_available(n.options.max_participants,n.participants)}
                            text={n.desc.replace(/(<([^>]+)>)/gi, "")}
                        >
                            <Card className={'cal-display'} slot="media">
                                <div className={'cal-top-bar'}></div>
                                <div className={'cal-date'}>{this.formateTimestampDate(n.periode_start)}.</div>
                            </Card>
                        </ListItem>
                    </List>
                </Card>
                ))}
                </>
                }
                <br/>
                </>
            ):(
            <Block>
                <p>
                {this.state.org_display_name} har ingen kommende aktiviteter eller arrangementer du kan melde deg på.
                </p>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
            </Block>
            )
            }
            </PageBlock>
            }
            </>
            }
            {!this.state.loading &&
            <PageBlock width="700px" color="#dfe4ea">
                        {this.state.contact &&
                        <>
                        <BlockTitle>
                            Kundestøtte
                        </BlockTitle>
                        <Block>
                            <p>
                            For spørsmål knyttet til arrangementene eller salg av billetter, ta kontakt med:
                            </p>
                            <b>
                            <p>
                            Telefon: {this.state.contact.tel}
                            </p>
                            <p>
                            E-post: {this.state.contact.email}
                            </p>
                            </b>
                        </Block>
                        </>
                        }
                        {this.state.org_name &&
                        <>
                                <BlockTitle>Om arrangøren</BlockTitle>
                                <Block>
                                    <p>
                                    Arrangørens juridiske navn er <b>{this.state.org_name}</b>. {this.state.org_name} bruker Påmeldinger.no til å administrere sine arrangementer. {this.state.web_page && <>Finn ut mer om {this.state.org_name} på deres hjemmeside: <Link style={{textDecoration:'underline'}} target="_blank" external href={this.addhttp(this.state.web_page)}><b>{this.state.web_page}</b></Link></>}
                                    </p>
                                </Block>
                        </>
                        }
                        {this.state.brreg &&
                        <>
                        <BlockTitle>
                            Besøksadresse
                        </BlockTitle>
                        <Block>
                            <p>
                            {this.state.org_name} holder til: <b>{this.state.org_adr}, {this.state.org_zip_code} {this.state.org_zip_city}</b>
                            </p>
                        </Block>
                        <BlockTitle>
                            Refundering
                        </BlockTitle>
                        <Block>
                            <p>
                            {this.state.org_name} refunderer ikke solgte billetter. Untak er dersom arrangementer blir avlyst, og avlysningen ikke skyldes forhold utenfor {this.state.org_name} sin kontroll.
                            </p>
                        </Block>
                        <BlockTitle>
                            Valuta
                        </BlockTitle>
                        <Block>
                            <p>
                            Alle transaksjoner er i Norske kroner (NOK).
                            </p>
                        </Block>
                        </>
                        }
                        <br/>
                    </PageBlock>
                }
            {this.render_bottombar()}
        </Page>
    }
};